<div class="info-block">
  <span class="fa fa-info-circle" aria-hidden="true"></span>
  <div class="info-text">
    <ng-content></ng-content>
  </div>
</div>
